import __request__ from "routing/request";
export function list(page = 1, per_page = 50, query, requestOptions) {
  return __request__("GET", "/events/definitions", null, { "page": page, "per_page": per_page, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(schedule2 = true, JSONBody, requestOptions) {
  return __request__("POST", "/events/definitions", JSONBody, { "schedule": schedule2 }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDelete(Entitiestoremove, requestOptions) {
  return __request__("POST", "/events/definitions/bulk_delete", Entitiestoremove, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkSchedule(Eventdefinitionstoenable, requestOptions) {
  return __request__("POST", "/events/definitions/bulk_schedule", Eventdefinitionstoenable, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkUnschedule(Eventdefinitionstodisable, requestOptions) {
  return __request__("POST", "/events/definitions/bulk_unschedule", Eventdefinitionstodisable, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getById(JSONbody, requestOptions) {
  return __request__("POST", "/events/definitions/byIds", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "title", page = 1, per_page = 50, query, filters, order = "asc", requestOptions) {
  return __request__("GET", "/events/definitions/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function suggestTags(query, limit = 10, requestOptions) {
  return __request__("GET", "/events/definitions/tags", null, { "query": query, "limit": limit }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateEventDefinition(JSONbody, requestOptions) {
  return __request__("POST", "/events/definitions/validate", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validateEventDefinitionCronExpression(JSONbody, requestOptions) {
  return __request__("POST", "/events/definitions/validate/cron_expression", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(definitionId, schedule2 = true, JSONBody, requestOptions) {
  return __request__("PUT", `/events/definitions/${definitionId}`, JSONBody, { "schedule": schedule2 }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(definitionId, requestOptions) {
  return __request__("GET", `/events/definitions/${definitionId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(definitionId, requestOptions) {
  return __request__("DELETE", `/events/definitions/${definitionId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function clearNotificationQueue(definitionId, requestOptions) {
  return __request__("PUT", `/events/definitions/${definitionId}/clear-notification-queue`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function duplicate(definitionId, requestOptions) {
  return __request__("POST", `/events/definitions/${definitionId}/duplicate`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function execute(parameters, definitionId, requestOptions) {
  return __request__("POST", `/events/definitions/${definitionId}/execute`, parameters, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function schedule(definitionId, requestOptions) {
  return __request__("PUT", `/events/definitions/${definitionId}/schedule`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function unschedule(definitionId, requestOptions) {
  return __request__("PUT", `/events/definitions/${definitionId}/unschedule`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getWithContext(definitionId, requestOptions) {
  return __request__("GET", `/events/definitions/${definitionId}/with-context`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
